import '../sass/citrus-image-carousel.scss';

(() => {
    const $citrusImageCarousels = document.querySelectorAll('.citrus-image-carousel');

    if (!$citrusImageCarousels) return;

    $citrusImageCarousels.forEach($citrusImageCarousel => {
        const $carousel = $citrusImageCarousel.querySelector('.citrus-image-carousel__carousel');

        let carousel = null;

        const carouselAutoplayObserver = new IntersectionObserver(entries => {
            if (!entries || !carousel) return;

            entries.forEach(entry => {
                if (entry.isIntersecting && !carousel?.autoplay?.running) {
                    carousel.autoplay.start();
                }

                if (!entry.isIntersecting && carousel?.autoplay?.running) {
                    carousel.autoplay.stop();
                    carousel.slideTo(0);
                }
            });
        }, {
            threshold: 0.5
        });
    
        const initCarousel = () => {
            if (!$carousel) return;

            const swiperScript = document.querySelector('#citrus-theme-swiper-js');

            if (!swiperScript) return;

            swiperScript.addEventListener('load', () => {
                carousel = new Swiper($carousel, {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: false
                    },
                    autoplay: {
                        delay: 2000,
                    },
                    speed: 1000,
                    allowTouchMove: false,
                    pauseOnMouseEnter: false,
                });

                carousel.autoplay.stop();

                carouselAutoplayObserver.observe($citrusImageCarousel);
            });
        };

        initCarousel();
    });
})();
